import { useEffect, useState } from "react";
import { getAllBanks } from "../services/dashboard"; // adjust path as needed

export const useBankNames = () => {
  const [bankOptions, setBankOptions] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchBankNames = async () => {
    setLoading(true);
    try {
      const response = await getAllBanks();
      const bankList = response?.data || [];
      const bankNames = bankList.map(
        (bank: { bank_name: string }) => bank.bank_name
      );
      setBankOptions(bankNames);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Fetch only once on mount
    fetchBankNames();
  }, []);

  return { bankOptions, loading, fetchBankNames };
};
